<template>
  <div class="campus-info-container">
    <pc-navbar />
    <block-overview />
    <div class="campus-info-content">
      <block-campus-tab
        :tab-list="tabList"
        :active-index="activeIndex"
        @clickTab="clickTab"
      />
    </div>
  </div>
</template>
<script>
import PcNavbar from "@/components/base/navbar";
import BlockOverview from "./BlockOverview.vue";
import BlockCampusTab from "./BlockCampusTab.vue";
const TAB_LIST = [
  {
    name: "校招信息汇总",
  },
  {
    name: "校招日历",
  },
];
export default {
  components: {
    PcNavbar,
    BlockOverview,
    BlockCampusTab,
  },
  data() {
    return {
      titleInfo: "校园招聘",
      tabList: TAB_LIST,
      activeIndex: 0,
    };
  },
  methods: {
    clickTab(index) {
      this.activeIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.campus-info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f5f5f7;
  padding-top: 76px;
  .campus-info-content {
    width: 1200px;
    background-color: #fff;
    margin-top: 16px;
    border-radius: 12px;
  }
}
</style>
